import {
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects';

import { post } from '../../utils/request';
import makeSelectMain, { getMainClientInfo } from '../Main/selectors';
import {
  fetchPostAuthNotificationsFailure,
  fetchPostAuthNotificationsSuccess,
} from './actions';
import { FETCH_NOTIFICATIONS_ERROR_MSG, FETCH_POST_AUTH_NOTIFICATIONS } from './constants';
import AsyncStorage from '../../utils/AsyncStorage';

export function* fetchPostAuthNotificationsSaga({ baseUrl }) {
  try {
    const clientCode = yield select(getMainClientInfo('clientCode'));
    const loanNumber = yield select(makeSelectMain('selectedLoan'));
    const requestBody = { clientCode, loanNumber };
    const { notifications } = yield call(post, `${baseUrl}/notifications/postAuth`, requestBody);
    const stringifiedValue = yield call(AsyncStorage.getItem, 'notificationsModalAutoOpened');
    const notificationsModalAutoOpened = JSON.parse(stringifiedValue) || [];
    yield put(fetchPostAuthNotificationsSuccess(
      notifications,
      notificationsModalAutoOpened,
    ));
  } catch {
    yield put(fetchPostAuthNotificationsFailure(FETCH_NOTIFICATIONS_ERROR_MSG));
  }
}

export default (options) => function* watcherSaga() {
  yield takeLatest(FETCH_POST_AUTH_NOTIFICATIONS, fetchPostAuthNotificationsSaga, options);
};
